const showInProductRecruitingModal = require('airship/modules/product-research')

;(() => {
  window.showInProductRecruitingModal = showInProductRecruitingModal
})()
